var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLoginArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5851_44986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 10.0052C18.3307 5.40521 14.5974 1.67188 9.9974 1.67188C5.3974 1.67188 1.66406 5.40521 1.66406 10.0052C1.66406 14.6052 5.3974 18.3385 9.9974 18.3385C14.5974 18.3385 18.3307 14.6052 18.3307 10.0052ZM3.33073 10.0052C3.33073 6.32187 6.31406 3.33854 9.9974 3.33854C13.6807 3.33854 16.6641 6.32187 16.6641 10.0052C16.6641 13.6885 13.6807 16.6719 9.9974 16.6719C6.31406 16.6719 3.33073 13.6885 3.33073 10.0052ZM13.3307 10.0052L9.9974 13.3385L8.8224 12.1635L10.1391 10.8385H6.66406V9.17188H10.1391L8.81406 7.84687L9.9974 6.67188L13.3307 10.0052Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5851_44986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLoginArrow);
export default __webpack_public_path__ + "static/media/right-login-arrow.06454b56.svg";
export { ForwardRef as ReactComponent };